<script>
	import Logo from './Logo.svelte';
</script>

<div class="logo-loader">
	<Logo />
</div>

<style>
	.logo-loader {
		animation: spin 600ms ease infinite alternate;
		transform-origin: center;
		display: inline-block;
	}

	@keyframes spin {
		0% {
			transform: rotateY(0deg);
		}
		100% {
			transform: rotateY(180deg);
		}
	}
</style>
